var map = {
	"./bagy.png": 79683,
	"./corecommerce.png": 94839,
	"./dlojavirtual.png": 34300,
	"./dooca.png": 30018,
	"./fastcommerce.png": 68903,
	"./iluria.png": 98710,
	"./irroba.png": 79147,
	"./iset.png": 67111,
	"./jet.png": 88234,
	"./linx.png": 33660,
	"./lojaintegrada.png": 75189,
	"./lojamestre.png": 38626,
	"./magento.png": 11247,
	"./mercadoshops.png": 31832,
	"./mkx.png": 57242,
	"./nuvemshop.png": 20600,
	"./opencart.png": 43508,
	"./other.png": 5002,
	"./prestashop.png": 98980,
	"./shopify.png": 67272,
	"./tray.png": 35524,
	"./vnda.png": 23361,
	"./vtex.png": 75652,
	"./wapstore.png": 85508,
	"./wbuy.png": 98050,
	"./webstore.png": 88366,
	"./wix.png": 7722,
	"./woocommerce.png": 50754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36830;